import React from "react";
import { queriesPayeeRows } from "@query";
import { WSElement, WSText } from "@wingspanhq/fe-component-library";
import { selectorSearchRowName } from "../../../../shared/selectors/selectorSearchRowName";
import { useXWingspanPayerId } from "../../../Payees/routes/RoutePayeeDetails/useXWingspanPayerId";

export const PayeeName: React.FC<{ payeeId: string }> = ({ payeeId }) => {
  const xWingspanAccount = useXWingspanPayerId();
  // Name off the search row's server-resolved `profile.resolvedName`, the same
  // string the contractor list shows.
  const queryPayeeRow = queriesPayeeRows.searchPayeeRows.useQuery({
    filter: { id: { eq: payeeId } },
    page: { size: 1 },
    xWingspanAccount
  });
  const payeeRow = queryPayeeRow.data?.data?.[0];

  if (payeeRow) {
    return <>{selectorSearchRowName(payeeRow)}</>;
  } else if (queryPayeeRow.isError) {
    return <WSText.ParagraphXs color="red500">error</WSText.ParagraphXs>;
  } else {
    return <WSElement as="i" shimmer pb="L" style={{ display: "block" }} />;
  }
};
